import { AssignedTicketDevsApi, CompletedTicketsDevApi} from "../model/FetchTicketDevApiAdmin";

export function CompletedTicketsDevloper(ticketFilterData,currentPage){
    let url = `/getcompletedticketsdev?page=${currentPage}`

        const params = new URLSearchParams();
        if (ticketFilterData) {
                if (ticketFilterData.ticketHeading) {
                        params.append("heading", ticketFilterData.ticketHeading);
                }

                if (ticketFilterData.ticketTool) {
                        params.append("tool", ticketFilterData.ticketTool);
                }
                if (ticketFilterData.ticketType) {
                        params.append("type", ticketFilterData.ticketType);
                }

                if (ticketFilterData.ticketId) {
                        params.append("id", ticketFilterData.ticketId);
                }

                if (ticketFilterData.ticketDate) {
                        params.append("date", ticketFilterData.ticketDate);
                }
                if (ticketFilterData.ticketStatus) {
                        params.append("status", ticketFilterData.ticketStatus);
                }

                if (params.toString()) {
                        url += `&${params.toString()}`;
                }
        }
        console.log(url);
    let response = CompletedTicketsDevApi(url)
    // console.log(response);
    return response
}
export function AssignedTicketsDevloper(ticketFilterData,currentPage){
    let url = `/getassignedticketsdev?page=${currentPage}`

        const params = new URLSearchParams();
        if (ticketFilterData) {
                if (ticketFilterData.ticketHeading) {
                        params.append("heading", ticketFilterData.ticketHeading);
                }

                if (ticketFilterData.ticketTool) {
                        params.append("tool", ticketFilterData.ticketTool);
                }
                if (ticketFilterData.ticketType) {
                        params.append("type", ticketFilterData.ticketType);
                }

                if (ticketFilterData.ticketId) {
                        params.append("id", ticketFilterData.ticketId);
                }

                if (ticketFilterData.ticketDate) {
                        params.append("date", ticketFilterData.ticketDate);
                }
                if (ticketFilterData.ticketStatus) {
                        params.append("status", ticketFilterData.ticketStatus);
                }

                if (params.toString()) {
                        url += `&${params.toString()}`;
                }
        }
        console.log(url);
    let response = AssignedTicketDevsApi(url)
    // console.log("assigne tickets in vm");
    // console.log(response);
    return response
}